import React, { useRef, useMemo, useState } from 'react';
import classnames from 'classnames';
// import { Bubble, Icon, Button } from 'tea-component';
import { Icon, Button } from 'tea-component';
import Loading from '@gp/components/Loading';
import NoData from '@gp/components/NoData';
import CardSlot from '@gp/components/CardSlot';
import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
import SelfAdaption, { ISelfAdaptionInstance } from './SelfAdaption';
import NumberModal from './NumberModal';

import type { IBaseProps } from '@home/types/common';
import type { KeyMetricsCardListItemType, ModalListItemType } from '../../types';

import './index.scss';

interface IKeyMetricsCardProps extends IBaseProps {
  loading: boolean;
  data: KeyMetricsCardListItemType;
  max: number;
}

const KeyMetricsCard: React.FC<IKeyMetricsCardProps> = (props) => {
  const { style, className, loading, data, max } = props;
  const { type, visibleTime, title, time, num, list } = data || {};
  const isImgCard = type === 'img';

  const selfAdaption = useRef<ISelfAdaptionInstance | null>(null);

  const [visible, setVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalList, setModalList] = useState<ModalListItemType[]>([]);
  const [showMoreBtn, setShowMoreBtn] = useState(false);

  // const cardTitle = useMemo<React.ReactElement>(
  //   () => (
  //     <div className="dbg-dashboard-card__title">
  //       {title}
  //       {visibleTime && <span className="dbg-dashboard-card__sub-title">{time || '-'}</span>}
  //     </div>
  //   ),
  //   [visibleTime, title, time],
  // );

  const cardTitle = useMemo<string>(() => {
    if (!visibleTime) return title;
    return `${title} ${time || '-'}`;
  }, [visibleTime, title, time]);

  const isNoData = useMemo<boolean>(() => !num, [num]);
  const handleClickImgCardMore = (e?: React.SyntheticEvent) => {
    e?.stopPropagation();
    selfAdaption.current?.openMoreModal();
  };

  return (
    <CardSlot
      style={style}
      className={classnames('dbg-dashboard-card', className, { 'dbg-dashboard-card--img-card': isImgCard })}
      title={cardTitle}
      visibleRightOperation={isImgCard}
      // rightDom={visibleTime && <div className="dbg-dashboard-card-time">{time || '-'}</div>}
      rightDom={
        !loading &&
        !isNoData &&
        isImgCard &&
        showMoreBtn && (
          <Button type="link" onClick={handleClickImgCardMore}>
            More
          </Button>
        )
      }
    >
      {loading && <Loading loading style={{ width: '100%', height: 73 }} />}
      {!loading && isNoData && <NoData height={73} />}
      {!loading && !isNoData && (
        <>
          <div className={classnames('dbg-dashboard-card-num', { 'dbg-dashboard-card-num--big-num': max > 99 })}>
            {num || '-'}
          </div>
          {type === 'text' ? (
            // REMARK: 设置display为none，临时隐藏分类，后续开发分类时，修改display为flex样式即可
            <div style={{ display: 'none' }} className="dbg-dashboard-card-text">
              {list.map((item, i) => {
                // const { name, icon, value, modalList, contextTip } = item || {};
                const { name, icon, value, modalList } = item || {};
                return (
                  <div
                    className="dbg-text-item"
                    style={{ cursor: modalList?.length ? '' : 'default' }}
                    key={i}
                    onClick={() => {
                      if (Array.isArray(modalList) && modalList?.length) {
                        setVisible(!visible);
                        setModalTitle(name || '');
                        setModalList(modalList || []);
                      }
                    }}
                  >
                    <div className="dbg-text-item-title">
                      {icon ? name : <EllipsisTextBubble className="dbg-text-item-name" text={name || '-'} />}
                      {icon && <Icon type={icon} className="dbg-text-item-icon" />}
                    </div>
                    <div className="dbg-text-item-value">{value || '-'}</div>
                  </div>
                );
              })}
            </div>
          ) : (
            <SelfAdaption ref={selfAdaption} cardTitle={cardTitle} data={data} setShowMoreBtn={setShowMoreBtn} />
          )}
          <NumberModal
            visible={visible}
            title={modalTitle}
            data={modalList}
            close={() => {
              setVisible(!visible);
            }}
          />
        </>
      )}
    </CardSlot>
  );
};

export default React.memo(KeyMetricsCard);
